const convertToSeconds = (hours, minutes) => {
  const hoursInSeconds = hours ? parseInt(hours) * 3600 : 0;
  const minutesInSeconds = minutes ? parseInt(minutes) * 60 : 0;
  return hoursInSeconds + minutesInSeconds;
};

export function template1(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    perField: formData.perField,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      cut: formData.cut,
      cutAmount: formData.cutAmount,
      cutUnit: formData.cutUnit,
      locationId: formData.locationId,
      ensilationText: formData.ensilationText,
      ensilationAmount: formData.ensilationAmount,
      ensilationUnit: formData.ensilationUnit,
      drymatter: formData.drymatter,
      weight: formData.weight,
    }
  };
}
export function template2(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    perField: formData.perField,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      cut: formData.cut,
      cutAmount: formData.cutAmount,
      cutUnit: formData.cutUnit,
      ensilationText: formData.ensilationText,
      ensilationAmount: formData.ensilationAmount,
      ensilationUnit: formData.ensilationUnit,
      drymatter: formData.drymatter,
      weight: formData.weight,
    }
  };
}
export function template3(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      cut: formData.cut
    }
  };
}
export function template4(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      totalHarvest: formData.totalHarvest,
      waterPercent: formData.waterPercent
    }
  };
}
export function template5(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      mixText: formData.mixText,
      amount: formData.amount,
      unit: formData.unit
    }
  };
}
export function template6(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    perField: formData.perField,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      comboSowingAmount: formData.comboSowingAmount,
      sowingTypeText: formData.sowingTypeText,
      comboFertiAmount: formData.comboFertiAmount,
      mineralFertiType: formData.mineralFertiType,
      comboSowingUnit: formData.comboSowingUnit,
      comboFertiUnit: formData.comboFertiUnit
    }
  };
}
export function template7(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    perField: formData.perField,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      type: formData.type,
      subType: formData.subType,
      amount: formData.amount === "" ? null : formData.amount,
      unit: formData.unit,
      planAmount: formData.planAmount === "" ? null : formData.planAmount,
      planUnit: formData.planUnit,
      season: formData.season === "" ? null : formData.season,
      manureStorageId: formData.manureStorageId,
      manureStorageName: formData.manureStorageName
    }
  };
}
export function template8(formData) {
  return {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    notes: formData.note,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    waterJournal: formData.waterJournal,
    waterJournalAdded: formData.waterJournalAdded,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName
    }
  };
}
export function template(formData) {
  const templateData = {
    farmId: formData.farmId,
    activityId: formData.activityId,
    activityName: formData.activityName,
    fieldIds: formData.fieldIds,
    startTime: formData.startTime,
    endTime: formData.startTime,
    vehicleAssetId: formData.vehicleAssetId,
    equipmentAssetId: formData.equipmentAssetId,
    weather: formData.weather,
    notes: formData.note,
    waterJournalAdded: formData.waterJournalAdded,
    netDuration: convertToSeconds(formData.timerHour, formData.timerMinutes),
    taskActivity: {
      activityId: formData.activityId,
      activityName: formData.activityName,
      effectApplication: formData.taskActivity?.effectApplication,
      growthStage: formData.taskActivity.growthStage,
      growthStageSub: formData.taskActivity.growthStageSub ?
        formData.taskActivity.growthStageSub : formData.taskActivity.growthStageSubSubType,
      growthStageSubSubType: formData.taskActivity.growthStageSub ?
        formData.taskActivity.growthStageSubSubType : null,
      pestSubList: formData.taskActivity.pestSubList,
      pestData: formData.taskActivity.pestData,
      crop: formData.taskActivity.crop,
      windSpeed: formData.taskActivity?.windSpeed,
      reason: formData.taskActivity?.reason,
      firstHarvestDate: formData.taskActivity.firstHarvestDate,
      harvestDate: formData.taskActivity.harvestDate,
      pesticideType: formData.pesticideType,
      performedBy: formData.taskActivity?.performedBy,
      waterUnit: formData.taskActivity?.waterUnit,
      waterAmount: formData.taskActivity?.waterAmount
    }
  };

  if (formData.waterJournalAdded) {
    templateData.waterJournal = {
      sprayerType: formData.waterJournal.sprayerType,
      lessThan2PCSlope: formData.waterJournal.lessThan2PCSlope,
      reqdVegetatedBufferZone: formData.waterJournal.reqdVegetatedBufferZone,
      nozzleName: formData.waterJournal.nozzleName,
      nozzleFactory: formData.waterJournal.nozzleFactory,
      developmentStage: formData.waterJournal.developmentStage,
      reqdDistanceToSurfaceWater: formData.waterJournal.reqdDistanceToSurfaceWater,
      fogSprayerModel: formData.waterJournal.fogSprayerModel,
      nozzlesProvideTargetMovement: formData.waterJournal.nozzlesProvideTargetMovement,
      damperSetForOptimalDistribution: formData.waterJournal.damperSetForOptimalDistribution,
      oneEndClosedToAvoidSurfaceWater: formData.waterJournal.oneEndClosedToAvoidSurfaceWater,
      sprayingTechnique: formData.waterJournal.sprayingTechnique,
      vegetatedBufferExists: formData.waterJournal.vegetatedBufferExists,
      bufferZonePlacement: formData.waterJournal.bufferZonePlacement,
      locationAndDistance: formData.waterJournal.locationAndDistance,
      distanceOfSurfaceWaterExists: formData.waterJournal.distanceOfSurfaceWaterExists,
      distanceOfSurfaceWater: formData.waterJournal.distanceOfSurfaceWater,
      vegitatedBufferZone: formData.waterJournal.vegitatedBufferZone,
      distanceOfVegitagedBufferZone: formData.waterJournal.distanceOfVegitagedBufferZone,
      windSpeed3: formData.waterJournal.windSpeed3,
      sprayingIntoCrop: formData.waterJournal.sprayingIntoCrop,
      equipmentModel: formData.waterJournal.equipmentModel,
      distanceToWaterBody: formData.waterJournal.distanceToWaterBody,
      distanceToWaterWell: formData.waterJournal.distanceToWaterWell,
      driftReduction: formData.waterJournal.driftReduction,
      maxDrivingSpeed: formData.waterJournal.maxDrivingSpeed,
      pressure: formData.waterJournal.pressure,
      nozzleHeight: formData.waterJournal.nozzleHeight,
      cultureBySpray: formData.waterJournal.cultureBySpray,
      fieldAge: formData.waterJournal.fieldAge,
      amount: formData.waterJournal.amount,
      ptoSpeed: formData.waterJournal.ptoSpeed,
      airSpeed: formData.waterJournal.airSpeed,
      sprayingTechniqueMeter: formData.waterJournal.sprayingTechniqueMeter
    };
  }

  return templateData;
}